import { API_WS_URL } from "@/consts/sys_config";
import { useUserInfo } from "@/store/user-info";
import { inApp } from "@/utils/interface";
import { ConnectManager, OrderBookSubscriptionManager, SOCKET_KEY } from "@yn/socket";
import { useEffect, useRef } from "react";

function getWebSocketUrl(): string {
    if ( typeof window === "undefined" ) {
        return "";
    }
    const protocol = "wss";
    // Use NEXT_PUBLIC_WS_DOMAIN for WebSocket host, fallback to NEXT_PUBLIC_DOMAIN or window.location.host
    const wsDomain = process.env.NEXT_PUBLIC_WS_DOMAIN || "";
    const domain = process.env.NEXT_PUBLIC_DOMAIN || "";
    // Remove protocol prefix if exists
    const cleanWsDomain = wsDomain.replace( /^https?:\/\//, "" );
    const cleanDomain = domain.replace( /^https?:\/\//, "" );
    const host = cleanWsDomain || cleanDomain || window.location.host;
    return `${protocol}://${host}${API_WS_URL}/ws/orderbook`;
}

export function useSocketInit() {
    const wsInstance = useRef( ConnectManager.getInstance( SOCKET_KEY.ORDERBOOK ) );
    const initialized = useRef( false );

    // 监听用户 ID 变化，登录/退出时同步 userId 到 ConnectManager
    const userId = useUserInfo( ( state ) => state.userId );

    useEffect( () => {
        // userId 为 0 视为未登录，传 undefined 清除；否则设置真实 userId
        wsInstance.current.setUserId( userId || undefined );
    }, [ userId ] );

    useEffect( () => {
        if ( !initialized.current ) {
            // 设置订阅管理器（orderbook 使用订单盘口订阅管理器）
            if ( !wsInstance.current.subscriptionManager ) {
                wsInstance.current.setSubscriptionManager( new OrderBookSubscriptionManager() );
            }
            // 设置平台信息（h5 或 app），将在 ping 心跳中携带
            wsInstance.current.setPlatform( inApp() ? "app" : "h5" );
            initialized.current = true;
        }

        wsInstance.current.connect( getWebSocketUrl() );

        return () => {
            wsInstance.current.disconnect();
        };
    }, [] );

    return wsInstance.current;
}
